import { Injectable, inject } from '@angular/core';
import { SupabaseClient } from '@supabase/supabase-js';
import { Database } from 'supabase/types/supabase';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private supabaseClient = inject<SupabaseClient<Database>>(SupabaseClient);

  /**
   * Get JWT claims directly from Supabase auth
   * This method provides the raw JWT payload for advanced use cases
   */
  getClaims() {
    return this.supabaseClient.auth.getClaims();
  }

  /**
   * Get user information extracted from JWT claims
   * This is a convenience method that provides a user object similar to getUser()
   */
  getUser() {
    return this.getClaims().then(({ data, error }) => {
      if (error || !data?.claims) {
        return null;
      }

      // Extract user information from JWT claims
      const claims = data.claims;
      return {
        id: claims.sub, // User ID is in the 'sub' claim
        email: claims['email'],
        role: claims.role,
        aud: claims.aud,
        // Add other common user fields from the claims as needed
        app_metadata: claims['app_metadata'] || {},
        user_metadata: claims['user_metadata'] || {},
      };
    });
  }
}
